import { createFileRoute } from '@tanstack/react-router'
import { SensorKitHealthNew } from "@/views/sensor-kit-health-new";

export const Route = createFileRoute(
  '/_authenticated/_staff/sensor-kit-health-new',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <SensorKitHealthNew />
}
